import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

const Contact = () => {
    const { t } = useLanguage();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [status, setStatus] = useState(''); // 'sending', 'success', 'error'

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('sending');

        try {
            const response = await fetch("https://api.web3forms.com/submit", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify({
                    access_key: "1351c750-aea4-4b01-a595-aff6641675e0",
                    ...formData,
                }),
            });

            const result = await response.json();

            if (result.success) {
                setStatus('success');
                setFormData({ name: '', email: '', subject: '', message: '' });
                // Reset success message after 5 seconds
                setTimeout(() => setStatus(''), 5000);
            } else {
                setStatus('error');
            }
        } catch (error) {
            console.error("Error submitting form", error);
            setStatus('error');
        }
    };

    return (
        <div className="page-content contact-page">
            <h2>{t('contact.title')}</h2>

            <div className="contact-content">
                {/* 1. Detail Section (Image + Text wrapping) */}
                <div className="contact-detail-section">
                    <div className="bio-image-wrapper">
                        <img
                            src="images/12jpg.jpeg"
                            alt="Profile"
                        />
                    </div>

                    <div className="bio-intro-text">
                        <p className="bio-intro" dangerouslySetInnerHTML={{ __html: t('about.bio1') }}></p>
                    </div>

                    <div className="bio-full-text">
                        {Array.isArray(t('about.bio2')) ? (
                            t('about.bio2').map((paragraph, index) => (
                                <p key={index} className="bio-detail" dangerouslySetInnerHTML={{ __html: paragraph }}></p>
                            ))
                        ) : (
                            <p className="bio-detail" dangerouslySetInnerHTML={{ __html: t('about.bio2') }}></p>
                        )}
                    </div>

                    <div className="bio-experience">
                        {/* Placeholder for experience */}
                    </div>


                </div>

                {/* 3. Form Column (Right) */}
                <div className="contact-form-col">
                    <h3>{t('contact.getInTouch')}</h3>

                    <form className="contact-form" onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="name">{t('contact.name')}</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                disabled={status === 'sending'}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">{t('contact.email')}</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                disabled={status === 'sending'}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="subject">{t('contact.subject')}</label>
                            <input
                                type="text"
                                id="subject"
                                name="subject"
                                value={formData.subject}
                                onChange={handleChange}
                                required
                                disabled={status === 'sending'}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="message">{t('contact.message')}</label>
                            <textarea
                                id="message"
                                name="message"
                                rows="5"
                                value={formData.message}
                                onChange={handleChange}
                                required
                                disabled={status === 'sending'}
                            ></textarea>
                        </div>
                        <button
                            type="submit"
                            className="submit-btn"
                            disabled={status === 'sending'}
                        >
                            {status === 'sending' ? t('contact.sending') : t('contact.send')}
                        </button>

                        {status === 'success' && (
                            <div style={{ marginTop: '1rem', fontWeight: '500' }}>
                                {t('contact.successMessage')}
                            </div>
                        )}
                        {status === 'error' && (
                            <div style={{ color: '#ef4444', marginTop: '1rem', fontWeight: '500' }}>
                                {t('contact.errorMessage')}
                            </div>
                        )}
                    </form>

                    <div className="social-links-area">
                        <a href="mailto:hello@saranaess.com" className="email-link">hello@saranaess.com</a>
                        <div className="social-icons">
                            <a href="https://www.linkedin.com/in/sarahnaess" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                                    <rect x="2" y="9" width="4" height="12"></rect>
                                    <circle cx="4" cy="4" r="2"></circle>
                                </svg>
                            </a>
                            {/* <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                                </svg>
                            </a> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
